/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGlobalVariationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteGlobalVariationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteGlobalVariationSecurity = {
  option1?: DeleteGlobalVariationSecurityOption1 | undefined;
  option2?: DeleteGlobalVariationSecurityOption2 | undefined;
};

export type DeleteGlobalVariationRequest = {
  /**
   * The ID of the variation to delete
   */
  variationId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteGlobalVariationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteGlobalVariationSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteGlobalVariationSecurityOption1$Outbound,
  DeleteGlobalVariationSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteGlobalVariationSecurityOption1ToJSON(
  deleteGlobalVariationSecurityOption1: DeleteGlobalVariationSecurityOption1,
): string {
  return JSON.stringify(
    DeleteGlobalVariationSecurityOption1$outboundSchema.parse(
      deleteGlobalVariationSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteGlobalVariationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteGlobalVariationSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteGlobalVariationSecurityOption2$Outbound,
  DeleteGlobalVariationSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteGlobalVariationSecurityOption2ToJSON(
  deleteGlobalVariationSecurityOption2: DeleteGlobalVariationSecurityOption2,
): string {
  return JSON.stringify(
    DeleteGlobalVariationSecurityOption2$outboundSchema.parse(
      deleteGlobalVariationSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteGlobalVariationSecurity$Outbound = {
  Option1?: DeleteGlobalVariationSecurityOption1$Outbound | undefined;
  Option2?: DeleteGlobalVariationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteGlobalVariationSecurity$outboundSchema: z.ZodMiniType<
  DeleteGlobalVariationSecurity$Outbound,
  DeleteGlobalVariationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteGlobalVariationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteGlobalVariationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteGlobalVariationSecurityToJSON(
  deleteGlobalVariationSecurity: DeleteGlobalVariationSecurity,
): string {
  return JSON.stringify(
    DeleteGlobalVariationSecurity$outboundSchema.parse(
      deleteGlobalVariationSecurity,
    ),
  );
}

/** @internal */
export type DeleteGlobalVariationRequest$Outbound = {
  variation_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteGlobalVariationRequest$outboundSchema: z.ZodMiniType<
  DeleteGlobalVariationRequest$Outbound,
  DeleteGlobalVariationRequest
> = z.pipe(
  z.object({
    variationId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      variationId: "variation_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteGlobalVariationRequestToJSON(
  deleteGlobalVariationRequest: DeleteGlobalVariationRequest,
): string {
  return JSON.stringify(
    DeleteGlobalVariationRequest$outboundSchema.parse(
      deleteGlobalVariationRequest,
    ),
  );
}
